module.exports = __webpack_public_path__ + "media/images/common/cb-1-fc75461a4db6628185b1a9ab4ab978b1.jpg";